import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchAllEvents, fetchEventPageSeo, fetchEventBanner } from "../Adapter/PageAdapter";
import { baseImage_path } from "../variables/Variables";
import { stripHtmlForMeta } from "../utils/seoMetaText";
// import useSeo from "../hooks/useSeo";
// import SeoHelmet from "../components/SeoHelmet";
import { Helmet } from "react-helmet-async";
import BannerImg from "../assets/images/Events.jpg";
// import EventImg from "../assets/images/speci-detail/event.jpg";
import BlkrawImg from "../assets/images/speci-detail/blkarw.svg";

// Helper function to limit text to a specific word count
const truncateWords = (text, wordLimit = 15) => {
    if (!text) return "";
    const words = text.split(/\s+/);
    return words.length > wordLimit
        ? words.slice(0, wordLimit).join(" ") + "..."
        : text;
};

const Events = () => {
    const [bannerData, setBannerData] = useState([]);
    const [events, setEvents] = useState([]);
    const navigate = useNavigate();
    const [seoData, setSeoData] = useState(null);

    useEffect(() => {
        const loadSeo = async () => {
            try {
                console.log("Calling fetchEventPageSeo...");
                const res = await fetchEventPageSeo();
                console.log("API Response:", res);
                if (res && res.data) {
                    setSeoData(res.data);
                }
            } catch (e) {
                console.error("Direct SEO fetch failed:", e);
            }
        };

        loadSeo();
    }, []);

    // const seoData = useSeo(fetchEventPageSeo);

    useEffect(() => {
        const fetchData = async () => {
            const bannerResponse = await fetchEventBanner();
            if (bannerResponse && bannerResponse.data) {
                setBannerData(bannerResponse.data);
            }
        };

        fetchData();
    }, []);

    // Fetch all events on component mount
    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const response = await fetchAllEvents();
                if (response && response.data) {
                    setEvents(response.data);
                }
            } catch (error) {
                console.error("Error fetching events:", error);
            }
        };

        fetchEvents();
    }, []);

    // const handleViewEventDetails = (id) => {
    //     navigate(`/events-details/${id}`);
    // };
    const handleViewEventDetails = (id, slug) => {
        // const Formaterslug = slug.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)+/g, '');
        localStorage.setItem("selectedEventId", id);
        navigate(`/events/${slug}`);
    };

    return (
        <>
            {/* {seoData && <SeoHelmet seoData={seoData} />} */}
            {seoData && (
                <Helmet>
                    <title>{seoData.seo_title}</title>
                    <meta name="title" content={seoData.meta_title} />
                    <meta name="description" content={stripHtmlForMeta(seoData.meta_description)} />
                    <meta name="keywords" content={seoData.meta_keywords} />

                    <meta property="og:title" content={seoData.og_title} />
                    <meta property="og:description" content={stripHtmlForMeta(seoData.og_description)} />
                    <meta property="og:type" content={seoData.og_type} />
                    <meta property="og:url" content={seoData.og_url} />
                    <meta property="og:image" content={`${baseImage_path}/${seoData.og_image}`} />
                    <meta property="og:locale" content={seoData.og_locale} />
                    <meta property="og:site_name" content={seoData.og_site_name} />
                    <meta property="article:modified_time" content={seoData.article_modified_time} />

                    <meta name="twitter:card" content={seoData.twitter_card} />
                    <meta name="twitter:title" content={seoData.twitter_title} />
                    <meta name="twitter:description" content={stripHtmlForMeta(seoData.twitter_description)} />
                    <meta name="twitter:image" content={`${baseImage_path}/${seoData.twitter_image}`} />
                    <meta name="twitter:site" content={seoData.twitter_site} />

                    <link rel="canonical" href={seoData.canonical_link} />

                    {/* Custom scripts injection */}
                    {seoData.custom_scripts && (
                        <script type="text/javascript" dangerouslySetInnerHTML={{ __html: seoData.custom_scripts }} />
                    )}
                </Helmet>
            )}
            {/* Banner section */}
            <section className="banner-spac">
                <div className="cust-container">
                    <div className="banner-box">
                        {bannerData && bannerData[0]?.img_path ? (
                            <img
                                src={`${baseImage_path}${bannerData[0].img_path.replace('.', '')}`}
                                alt={bannerData[0].banner_heading || "Events"}
                            />
                        ) : (
                            <img src={BannerImg} alt="Events" />
                        )}
                        <div className="ban-con">
                            <h1>{bannerData[0]?.banner_heading || 'Events'}</h1>
                        </div>
                    </div>
                </div>
            </section>

            {/*  */}
            <section className="our-video-sec mrgntop70 margnbot90">
                <div className="cust-container">
                    <div className="row">
                        {events.map((event, index) => (
                            <div
                                key={index}
                                className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 mb-4"
                            >
                                <div className="our-video-sec-item event-items">
                                    <div className="our-video-img">
                                        <img src={`${baseImage_path}${event.main_img_path || "images/events/events-img.png"}`}
                                            alt={event.name} />
                                    </div>
                                    <div className="our-video-desc our-vdo-desc-cta-green">
                                        <h5>{event.heading}</h5>
                                        {/* <p>{truncateWords(event.description, 15)}</p> */}
                                        <p dangerouslySetInnerHTML={{ __html: truncateWords(event.description || "No Dscription Available", 15) }} />
                                        <button
                                            className="btn with-arrow"
                                            onClick={() => handleViewEventDetails(event.id, event.slug)}
                                            style={{ paddingLeft: "0px", fontWeight: "bold", color: "#58595b" }}
                                        >
                                            View Event Details <img src={BlkrawImg} alt="" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default Events;
